import React from 'react';
import {Container, Header} from 'semantic-ui-react';
import styled from 'styled-components';

const Complete = () => {
  return (
    <StyledContainer>
      <Title as="h1">送信完了</Title>
      <Message>
        <p>お問い合わせの送信が完了しました。</p>
        <p>確認メールが届かない場合は、迷惑メールをご確認いただき、</p>
        <p>「@ac-mihara.jp」からのメール受信を許可してください。</p>
      </Message>

      <Actions>
        <StyledLink href="/">TOPへ戻る</StyledLink>
      </Actions>
    </StyledContainer>
  );
};

export default Complete;

const StyledContainer = styled(Container)`
  &&& {
    padding-top: 83px;
    width: 670px;
  }
`;

const Title = styled(Header)`
  &&& {
    font-family: HiraginoSans-W3;
    font-weight: normal;
    font-size: 30px;
    letter-spacing: 0.5px;
    color: #747474;
    text-align: center;
  }
`;

const Message = styled.div`
  margin: 55px 0;
  font-family: HiraginoSans-W3;
  font-size: 16px;
  font-weight: normal;
  line-height: 1.75;
  letter-spacing: normal;
  text-align: center;
  color: #2c2c2c;

  p {
    margin: 10px 0;
  }
`;

const Actions = styled.div`
  margin: 40px 0;
`;
const StyledLink = styled.a`
  display: block;
  margin: 0 auto;
  width: 240px;
  height: 56px;
  border-radius: 28.5px;
  color: #fff !important;
  background-color: #ef5350;
  line-height: 56px;
  text-align: center;
  font-size: 17px;
  font-family: HiraginoSans-W6;
  letter-spacing: 0.5px;

  &:hover {
    cursor: pointer;
    color: #ef5350 !important;
    background-color: #fff;
    border: 2px solid #ef5350;
  }
`;
